import { Injectable, OnDestroy } from '@angular/core';
import { QualifiedPersonSearchViewModelTotalTypePagedResultResponse, TotalType } from '@services/cleanfill-api/cleanfill-api.generated';
import { HttpQpService } from '@services/cleanfill-core/http-qp/http-qp.service';
import { ISearchQuery } from '@view-models/interfaces/search-query';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StoreQpService implements OnDestroy {
  private qualifiedPersonsSubj$ = new BehaviorSubject<QualifiedPersonSearchViewModelTotalTypePagedResultResponse>(null);
  qualifiedPersons$ = this.qualifiedPersonsSubj$.asObservable().pipe(map(payload => payload?.records || []));
  totalQualifiedPersons$ = this.qualifiedPersonsSubj$
    .asObservable()
    .pipe(map(payload => payload?.totals.find(total => total.type === TotalType.Total)?.value || 500));
  subscriptions = new Subscription();

  constructor(private qpHttp: HttpQpService) {}

  loadQps(query: ISearchQuery): void {
    this.subscriptions.add(this.qpHttp.loadQps(query).subscribe(res => this.qualifiedPersonsSubj$.next(res)));
  }

  inviteQp(payload, fn = () => {}): void {
    const sub = this.qpHttp.inviteQp(payload).subscribe(fn);
    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
